import { MasterButton, Modal, InputTextArea } from "App/Component/ui"
import { Grid } from "@material-ui/core"
import React, { useContext, useState } from "react"
import { FormContext } from "../../context/FormContext"
import {
  defaultToastSuccess,
  defaultToastError,
  removeLocalStorageAsFormData,
  isNull,
  toUTCFormat,
} from "App/utils/helpers"
import { DISABLED_BUTTON_SUBMIT, instance4, WMS_LGS_PO } from "App/constants"
import {
  STATUS_PROCESS,
  STATUS_TRANSAKSI_DISETUJUI,
  STATUS_TRANSAKSI_PENGAJUAN,
  urlChangeStatus,
  urlCreatePO,
  urlUpdatePO,
} from "../../helpers"

import { Alert } from "@material-ui/lab"

const SHOW_OPEN_DRAFT = {
  label: "OPEN DRAFT",
  color: "green",
  state: true,
  disabled: false,
}

export const SHOW_PROCESS = {
  label: "PROCESSS",
  color: "warning",
  state: true,
  disabled: false,
}

export const SHOW_UPDATE = {
  label: "UPDATE",
  color: "green",
  state: true,
  disabled: false,
}

const ModalSimpan = ({
  setShowModal,
  resetForm,
  setNewDataPoList,
  listPO,
  setListPO,
}) => {
  const [disabledOpenDraft, setDisabledOpenDraft] = useState(SHOW_OPEN_DRAFT)
  const [disabledProcess, setDisabledProcess] = useState(SHOW_PROCESS)
  const [disabledUpdate, setDisabledUpdate] = useState(SHOW_UPDATE)

  const { formData, setFormData, rowsRekomendasi } = useContext(FormContext)

  const handleClickOpenDraf = async (e) => {
    e.preventDefault()
    setDisabledOpenDraft(DISABLED_BUTTON_SUBMIT)
    try {
      if (
        formData.date === "" ||
        isNull(formData.gudang_id) ||
        isNull(formData.supplier_id)
      ) {
        defaultToastError("Tanggal / Gudang / Supplier tidak boleh kosong!")
        setDisabledOpenDraft(SHOW_OPEN_DRAFT)
      } else {
        if (listPO.length === 0) {
          defaultToastError(
            "Harap mengisi data barang transaksi po terlebih dahulu!",
          )
          setDisabledOpenDraft(SHOW_OPEN_DRAFT)
          setShowModal(false)
        } else {
          const api = await instance4.post(urlCreatePO, {
            tax: formData.tax,
            potongan: formData.potongan,
            supplier_id: formData.supplier_id,
            status_transaksi: STATUS_TRANSAKSI_PENGAJUAN,
            status: true,
            remark: formData.remark,
            penerima: formData.penerima,
            gudang_id: formData.gudang_id,
            date: toUTCFormat(formData.date),
            detail: listPO,
            barang: rowsRekomendasi,
          })
          const res = await api?.data
          if (res.status === 200) {
            setShowModal(false)
            defaultToastSuccess(res?.message)
            await setFormData({
              ...formData,
              idpo: res.data.header_po.id,
              nomorPo: res.data.header_po.nomorPO,
              isOpenDraf: true,
              isProcess: false,
            })

            setNewDataPoList(res.data.header_po.id)

            // localStorage.setItem(
            //   WMS_LGS_PO,
            //   JSON.stringify({
            //     ...formData,
            //     idpo: res.po_id,
            //     isOpenDraf: true,
            //     isProcess: false,
            //   })
            // );

            setNewDataPoList()
          } else {
            setDisabledOpenDraft(SHOW_OPEN_DRAFT)
            defaultToastError(res?.message)
          }
        }
      }
    } catch (error) {
      setDisabledOpenDraft(SHOW_OPEN_DRAFT)
      defaultToastError(error?.response?.data?.message)
    }
  }

  const handleClickProcess = async (e) => {
    e.preventDefault()
    setDisabledProcess(DISABLED_BUTTON_SUBMIT)
    try {
      if (formData.date === "") {
        defaultToastError("Tanggal tidak boleh kosong!")
        setDisabledProcess(SHOW_PROCESS)
      } else {
        const api = await instance4.post(urlChangeStatus, {
          id: formData.idpo,
          status: STATUS_PROCESS,
          status_transaksi: STATUS_TRANSAKSI_DISETUJUI,
          nomorPO: formData.nomorPO,
          remark: formData.catatan_proses,
        })
        const res = await api?.data
        if (res.status === 200) {
          removeLocalStorageAsFormData(WMS_LGS_PO)
          setShowModal(false)
          defaultToastSuccess(res?.message)
          setDisabledProcess(SHOW_PROCESS)
          setFormData({
            ...formData,
            isProcess: true,
            catatan_proses: "",
          })
        } else {
          defaultToastError(res?.message)
          setDisabledProcess(SHOW_PROCESS)
        }
        // resetForm();
      }
    } catch (error) {
      setDisabledProcess(SHOW_PROCESS)
      defaultToastError(error?.response?.data?.message)
    }
  }

  const handleClickUpdate = async (e) => {
    e.preventDefault()
    setDisabledUpdate(DISABLED_BUTTON_SUBMIT)
    try {
      if (formData.date === "") {
        defaultToastError("Tanggal tidak boleh kosong!")
        setDisabledUpdate(SHOW_UPDATE)
      } else {
        const api = await instance4.post(urlUpdatePO, {
          id: formData.idpo,
          penerima: formData.penerima,
          catatan: formData.remark,
          tax: formData.tax,
          potongan: formData.potongan,
          remark: formData.remark,
          date: toUTCFormat(formData.date),
          supplier_id: formData.supplier_id,
          detail: listPO,
        })
        const res = await api?.data
        if (res.status === 200) {
          setShowModal(false)
          defaultToastSuccess(res?.message)
          setNewDataPoList(formData.idpo)
        } else {
          setDisabledUpdate(SHOW_UPDATE)
          defaultToastError(res?.message)
        }
        // resetForm();
      }
    } catch (error) {
      setDisabledUpdate(SHOW_UPDATE)
      defaultToastError(error?.response?.data?.message)
    }
  }

  return (
    <Modal title={"Simpan"} show={setShowModal}>
      <Grid
        container
        direction="row"
        alignItems="center"
        style={{
          marginBottom: "1rem",
        }}
      >
        <ButtonCreate
          isOpenDraf={formData.isOpenDraf}
          disabledOpenDraft={disabledOpenDraft}
          handleClickOpenDraf={handleClickOpenDraf}
          disabledProcess={disabledProcess}
          handleClickProcess={handleClickProcess}
          disabledUpdate={disabledUpdate}
          handleClickUpdate={handleClickUpdate}
          formData={formData}
          setFormData={setFormData}
        />
      </Grid>
    </Modal>
  )
}

const ButtonCreate = ({
  isOpenDraf,
  disabledOpenDraft,
  handleClickOpenDraf,
  disabledProcess,
  handleClickProcess,
  setFormData,
  formData,
  disabledUpdate,
  handleClickUpdate,
}) => {
  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    })
  }

  return (
    <>
      {isOpenDraf ? (
        <>
          <Alert severity="info" variant="outlined" style={{ width: "100%" }}>
            Harap lakukan update ketika melakukan perubahan data
          </Alert>
          <MasterButton
            className={"mt-1 mb-2 w-full text-center"}
            type={"button"}
            color={disabledUpdate.color}
            onClick={(e) =>
              disabledUpdate.disabled ? null : handleClickUpdate(e)
            }
            name={disabledUpdate.label}
            size="lg"
          />
          <InputTextArea
            className="mt-1 w-full"
            value={formData.catatan_proses}
            label={"Keterangan/Catatan Sebelum Proses PO"}
            placeholder={""}
            onChange={handleChange("catatan_proses")}
            rows={"3"}
          />
          <MasterButton
            className={"mt-1 w-full text-center"}
            type={"button"}
            color={disabledProcess.color}
            onClick={(e) =>
              disabledProcess.disabled ? null : handleClickProcess(e)
            }
            name={disabledProcess.label}
            size="lg"
          />
        </>
      ) : (
        <MasterButton
          className={"mt-1 w-full text-center"}
          type={"button"}
          color={disabledOpenDraft.color}
          name={disabledOpenDraft.label}
          onClick={(e) =>
            disabledOpenDraft.disabled ? null : handleClickOpenDraf(e)
          }
          size="lg"
        />
      )}
    </>
  )
}

export default ModalSimpan
